import { render } from "./ValueItem.vue?vue&type=template&id=875624b4"
import script from "./ValueItem.vue?vue&type=script&lang=js"
export * from "./ValueItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__